import React from 'react';

export interface ImmunitiesPanelProps {
  /** List of immunities to display */
  immunities: string[];
  /** Optional className for additional styling */
  className?: string;
}

/**
 * ImmunitiesPanel Component
 * 
 * Displays all character immunities as badges.
 * Styled to match the codex detail page aesthetic.
 * 
 * Requirements: 3.7
 */
export const ImmunitiesPanel: React.FC<ImmunitiesPanelProps> = ({
  immunities,
  className = '',
}) => {
  if (!immunities || immunities.length === 0) {
    return null;
  }

  return (
    <div className={`immunities-panel ${className}`} data-testid="immunities-panel">
      <div className="immunities-list flex flex-wrap gap-2" data-testid="immunities-list">
        {immunities.map((immunity, index) => (
          <span
            key={`${immunity}-${index}`}
            className="immunity-badge"
            data-testid={`immunity-${index}`}
          >
            🛡️ {immunity}
          </span>
        ))}
      </div>
    </div>
  );
};
